import "./Button.scss"
import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

const Button = ({ to, styleName, className, ...rest }) => {
  const classnames = ["Button", `Button-${styleName}`, className].join(" ")
  if (to) {
    return <Link {...rest} to={to} className={classnames} />
  }
  return <button {...rest} className={classnames} />
}

Button.displayName = "Button"

Button.propTypes = {
  styleName: PropTypes.oneOf(["text", "submit", "primary", "inverted"]),
}

Button.defaultProps = {
  styleName: "text",
}

export default Button



// WEBPACK FOOTER //
// ./src/lib/Button.js